import { Box, Typography } from "@mui/material";
import { STAGE_OPTIONS } from "./options";

// "Pipeline" (all properties, no filter) has no group of its own in STAGE_OPTIONS — it is prepended
// here rather than added as a fourth group there, since it does not correspond to a stage a property
// can actually hold. The three real tabs are derived so a group's key or label only ever has to
// change in one place (options.js) instead of here as well.
const tabs = [
  { key: "all", label: "Pipeline" },
  ...STAGE_OPTIONS.map(({ key, label }) => ({ key, label })),
];

const PipelineTabs = ({
  activeStage,
  onStageChange,
  stageCounts,
}) => {
  // SOW 4 A1c, `pipeline/filter1_6`: 40 high, #EEF3EC on a #C6CFC6 border, tabs 0 16 with no gap;
  // the active tab is a white 38-high card. Values: files/tasks/sow4-a1-pipeline/spec.md c3.
  return (
    <Box
      sx={{
        height: "40px",
        display: "flex",
        alignItems: "center",
        borderRadius: "6px",
        backgroundColor: "#EEF3EC",
        border: "1px solid #C6CFC6",
        width: "fit-content",
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeStage === tab.key;

        return (
          <Box
            key={tab.key}
            onClick={() => onStageChange(tab.key)}
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: "16px",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: isActive ? "#FFFFFF" : "transparent",
              boxShadow: isActive ? "0px 2px 8px rgba(0,0,0,0.10)" : "none",
            }}
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "13px",
                fontWeight: isActive ? 700 : 600,
                lineHeight: 1,
                whiteSpace: "nowrap",
                color: isActive ? "#17270D" : "#4F5F4A",
              }}
            >
              {tab.label}

              <Box
                component="span"
                sx={{
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? "#43B017" : "#4F5F4A",
                }}
              >
                {stageCounts?.[tab.key] ?? 0}
              </Box>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PipelineTabs;